




































































import { Component, Vue, Prop } from 'vue-property-decorator';
import PageFooter from '@/pdf/components/PageFooter.vue';

@Component ({
  components: { PageFooter },
})
export default class AppendixCompass extends Vue {
  @Prop() readonly doc!: any;
}
